import * as React from 'react';

import cx from 'classnames';
import CloseIcon from 'themes/organic/assets/organic_close.svg';
import MenuIcon from 'themes/organic/assets/organic_hamburger.svg';

import { useNavigation } from 'hooks/navigation/useNavigation';

import { OrganicNavItemHome } from './OrganicNavItemHome';
import { OrganicNavItems } from './OrganicNavItems';

import s from './OrganicNavigation.module.css';

export const OrganicNavigation = () => {
  const {
    isMenuOpen,
    renderOverlay,
    renderMenuButton,
    renderCloseButton,
    renderMenuContainer,
    isFloating,
    floatingNavRef,
    navigationRef,
  } = useNavigation({
    styles: {
      overlay: s.overlay,
      overlayOpen: s.overlayOpen,
      overlayClosed: s.overlayClosed,
      menuButton: s.menuButton,
      menuContainer: s.menuContainer,
      menuContainerOpen: s.menuContainerOpen,
      menuContainerClosed: s.menuContainerClosed,
    },
  });

  return (
    <nav className={cx(s.root)} ref={navigationRef}>
      <div className={s.topPlaceholder} ref={floatingNavRef} id="top-of-nav" />
      {renderOverlay()}
      <div
        id="nav-bar"
        data-testid="nav-bar"
        className={cx(s.container, { [s.isFloating]: isFloating })}
      >
        <div className={s.innerContainer}>
          <div className={s.topContainer}>
            <OrganicNavItemHome />
            <div className={s.rightMobileContainer}>
              {renderMenuButton({
                content: <MenuIcon />,
              })}
            </div>
          </div>

          <ul className={s.bottomNavMenu}>
            <OrganicNavItems isMainNav />
          </ul>
        </div>
      </div>
      {renderMenuContainer({
        isOpen: isMenuOpen,
        content: (
          <div data-testid="mobile-menu" className={s.mobileMenuContainer}>
            {isMenuOpen && <OrganicNavItemHome />}
            {isMenuOpen && (
              <div className={s.closeButtonContainer}>
                {renderCloseButton({ content: <CloseIcon /> })}
              </div>
            )}
            <ul className={cx(s.menu, isMenuOpen ? s.menuOpen : s.menuClosed)}>
              <OrganicNavItems />
            </ul>
          </div>
        ),
      })}
    </nav>
  );
};
